<template>
  <div class="price-boost">
    <component v-if="status === 'loaded'" :is="layoutType" :teamShirts="teamShirts" :loggedin="siteConfig.username !== ''" :betSlipUrl="addToBetslipUrl" :event="event" :eventDate="eventDate" :scContent="scContent" :priceboostSelection="priceboostSelection"></component>
    <!-- show error message on frontend -->
    <div class="priceboost promo-container is-error" v-else-if="status === 'error'">
      <i class="fas fa-exclamation-circle"></i>
      <em>{{ userMessage }}</em>
    </div>
    <!-- <Terms 
      :content="getSCContent('terms')">
    </Terms> -->
    <div
      v-if="false"
      class="sticky-footer hide-lg"
    >
      <a :href="scContent.FieldValues.Parameters['link_cta']" class="button button--primary">{{ scContent.FieldValues.Parameters['copy_cta'] }}</a>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Single from "./Single.vue";
import Double from "./Double.vue";
import NoShirt from "./NoShirt.vue";
import Terms from "./Terms.vue";
import SingleReversed from "./SingleReversed.vue";

export default {
  components: {
    Single,
    SingleReversed,
    Double,
    NoShirt,
    Terms
  },
  props: ["scContent"],
  data() {
    return {
      status: null, // null | 'loaded' | 'error'
      teamShirts: {
        away: null,
        home: null,
        fallback: null
      },
      eventDate: null,
      event: null
    };
  },
  computed: {
    addToBetslipUrl() {
      const helpIndex = this.priceboostSelection == 1 ? 0 : 2;
      return `//sports.${this.siteConfig.label}/${
        this.siteConfig.language
      }/sports/addbets?ResultIDs=${
        this.event.Event.Market.Option[helpIndex]["@id"]
      }&GameIDs=${this.event.Event["@id"]}#sportId=${
        this.event["@id"]
      }&leagueIds=${this.event["@id"]}&eventId=${this.event.Event["@id"]}`;
    },
    priceboostSelection() {
      return this.scContent.FieldValues.Parameters[
        "config_priceboost-selection"
      ];
    },
    siteConfig() {
      return window.siteConfig;
    },
    promoContent() {
      return window.promoContent;
    },
    layoutType() {
      const layout = this.scContent.FieldValues.Parameters["config_layout"];
      const singleRgx = RegExp("single", "gi");
      const doubleRgx = RegExp("double", "gi");
      const noShirtRgx = RegExp("no_shirt", "gi");
      const singleReversedRgx = RegExp("reversed", "gi");

      if (singleRgx.test(layout)) return "Single";
      if (doubleRgx.test(layout)) return "Double";
      if (noShirtRgx.test(layout)) return "NoShirt";
      if (singleReversedRgx.test(layout)) return "SingleReversed";
      return "Double";
    },
    userMessage() {
      return this.$store.state.userMessage;
    }
  },
  methods: {
    getSCContent(itemName) {
      return this.promoContent.find(obj => {
        return obj.ItemName === itemName;
      });
    },
    loadEventId() {
      return new Promise((resolve, reject) => {
        const eventId = this.scContent.FieldValues.Parameters["data_event-id"];
        let event = null;
        if (this.$store.state.feedData && window.promoContent) {
          try {
            if (eventId !== "") {
              event = this.$store.state.feedData.BettingOffer.League.find(
                obj => {
                  return obj.Event["@id"] === eventId;
                }
              );
            } else {
              event = this.$store.state.feedData.BettingOffer.League[0];
            }
            this.event = event;
            resolve();
          } catch (e) {
            this.$store.commit(
              "SET_USERMESSAGE",
              `Configuration Error: EventID ${eventId} not found.`
            );
            reject("Error loading EventId");
          }
        } else {
          reject("Couldnt find EventId");
        }
      });
    },
    setJerseyUrls() {
      if (window.innerWidth >= 767) {
        this.teamShirts.home = `//media.itsfogo.com/media/mkt-content/img/jerseys/500x500/${
          this.event.Event["@player1Id"]
        }.png`;
        this.teamShirts.away = `//media.itsfogo.com/media/mkt-content/img/jerseys/500x500/${
          this.event.Event["@player2Id"]
        }.png`;
        this.teamShirts.fallback =
          "//media.itsfogo.com/media/mkt-content/img/jerseys/500x500/fallback.png";
      } else {
        this.teamShirts.home = `//media.itsfogo.com/media/mkt-content/img/jerseys/200x200/${
          this.event.Event["@player1Id"]
        }.png`;
        this.teamShirts.away = `//media.itsfogo.com/media/mkt-content/img/jerseys/200x200/${
          this.event.Event["@player2Id"]
        }.png`;
        this.teamShirts.fallback =
          "//media.itsfogo.com/media/mkt-content/img/jerseys/200x200/fallback.png";
      }
    },
    prerenderEventDate() {
      let momentFormat = "";
      switch (`${this.siteConfig.domain}/${this.siteConfig.language}`) {
        case "bwin.com/en":
          momentFormat = "DD/MM/YY";
          break;
        default:
          momentFormat = "DD.MM.YY";
          break;
      }
      this.eventDate = moment(this.event.Event["@date"]).format(momentFormat);
    }
  },
  mounted() {
    this.loadEventId()
      .then(() => {
        this.setJerseyUrls();
        this.prerenderEventDate();
        this.status = "loaded";
      })
      .catch(e => {
        console.log(e);
        this.status = "error";
      });
  }
};
</script>
<style lang="scss">
.priceboost {
  position: relative;
  color: var(--pb-color);
  @media (min-width: 991px) {
    max-width: 955px;
    margin: 0 auto;
  }
}
.jerseys {
  display: flex;
  align-items: center;
  flex: 1 0 0;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}
.event-content {
  position: relative;
  padding: 0.5rem;
  background-color: var(--pb-event-bg);
  margin-top: -3rem;
  z-index: 5;
  @media (min-width: 768px) {
    margin-top: -10rem;
  }
  @media (min-width: 991px) {
    margin-top: 0;
  }
  .title {
    font-size: 1.6rem;
    letter-spacing: 5px;
    text-align: center;
    position: relative;
    margin-bottom: 1rem;
    &::after {
      content: "";
      display: block;
      width: 80%;
      height: 1px;
      margin: 0 auto;
      background-color: var(--pb-title-delimiter);
    }
  }
}
.event {
  text-align: center;
  font-family: "Druk Wide";
  text-transform: uppercase;
  font-size: 2rem;
  line-height: 1;
  margin-bottom: 1rem;
}
.event__details {
  color: var(--pb-event-description-color);
}
.event__date {
  margin-right: 0.5rem;
}
.event__claim {
  font-size: 2rem;
  margin: 0.5rem 0;
  @media (min-width: 991px) {
    font-size: 2.3rem;
  }
  strong {
    font-weight: inherit;
    color: var(--pb-title-highlight);
  }
}
.event-odds {
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 80%;
  margin: 0 auto;
  text-align: center;
  font-family: "Druk Wide";
  font-size: 1.4rem;
  text-transform: uppercase;
}
.event-odds__now,
.event-odds__was {
  position: relative;
  width: 50%;
}
.event-odds__was {
  margin-right: 1rem;
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 2px;
    background-color: var(--pb-event-odds-previous-cross);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.event-odds__now {
  border: solid 3px var(--pb-event-odds-now-border);
}
a.event-odds__now {
  text-decoration: none;
  color: inherit;
  transition: all 0.15s ease-in-out;
  &:hover {
    text-decoration: none;
    color: var(--pb-event-odds-now-hover-color);
    background-color: var(--pb-event-odds-now-hover-bg);
  }
  &:focus {
    text-decoration: none;
    color: inherit;
  }
}
.event-odds__label {
  margin-right: 0.5rem;
}
.event-text {
  margin-top: 1rem;
  text-align: center;
}
.event-cta {
  width: 100%;
  text-align: center;
  margin-top: 1rem;
  display: none;
  @media (min-width: 991px) {
    display: block;
  }
}

.is-error .fa-exclamation-circle {
  color: var(--pb-error-icon-color);
}
</style>
